export const crossIcon = () => {
  return (
    <svg
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.5571 67.6279C52.0587 67.6279 67.0571 52.6295 67.0571 34.1279C67.0571 15.6264 52.0587 0.62793 33.5571 0.62793C15.0556 0.62793 0.0571289 15.6264 0.0571289 34.1279C0.0571289 52.6295 15.0556 67.6279 33.5571 67.6279Z"
        fill="#20187B"
        fillOpacity="0.1"
      />
      <path
        d="M35.3071 28.3779V27.1279H32.8071V28.3779H32.2896L30.3071 30.3604V33.8954L32.2896 35.8779H34.7896L35.3071 36.3954V37.8604L34.7896 38.3779H33.3246L32.8071 37.8604V37.1279H30.3071V38.8954L32.2896 40.8779H32.8071V42.1279H35.3071V40.8779H35.8246L37.8071 38.8954V35.3604L35.8246 33.3779H33.3246L32.8071 32.8604V31.3954L33.3246 30.8779H34.7896L35.3071 31.3954V32.1279H37.8071V30.3604L35.8246 28.3779H35.3071Z"
        fill="url(#paint0_linear_28_116)"
      />
      <path
        d="M46.0396 24.6279H49.5746L51.5571 22.6454V19.1104L49.5746 17.1279H46.0396L44.0571 19.1104V22.6454L44.1646 22.7529L42.8071 24.1104L40.8246 22.1279H37.8071V19.1104L35.8246 17.1279H32.2896L30.3071 19.1104V22.1279H27.2896L25.3071 24.1104L23.9496 22.7529L24.0571 22.6454V19.1104L22.0746 17.1279H18.5396L16.5571 19.1104V22.6454L18.5396 24.6279H22.0746L22.1821 24.5204L23.5396 25.8779L21.5571 27.8604V30.8779H18.5396L16.5571 32.8604V36.3954L18.5396 38.3779H21.5571V41.3954L23.5396 43.3779L22.1821 44.7354L22.0746 44.6279H18.5396L16.5571 46.6104V50.1454L18.5396 52.1279H22.0746L24.0571 50.1454V46.6104L23.9496 46.5029L25.3071 45.1454L27.2896 47.1279H30.3071V50.1454L32.2896 52.1279H35.8246L37.8071 50.1454V47.1279H40.8246L42.8071 45.1454L44.1646 46.5029L44.0571 46.6104V50.1454L46.0396 52.1279H49.5746L51.5571 50.1454V46.6104L49.5746 44.6279H46.0396L45.9321 44.7354L44.5746 43.3779L46.5571 41.3954V38.3779H49.5746L51.5571 36.3954V32.8604L49.5746 30.8779H46.5571V27.8604L44.5746 25.8779L45.9321 24.5204L46.0396 24.6279ZM21.5571 21.6104L21.0396 22.1279H19.5746L19.0571 21.6104V20.1454L19.5746 19.6279H21.0396L21.5571 20.1454V21.6104ZM21.5571 49.1104L21.0396 49.6279H19.5746L19.0571 49.1104V47.6454L19.5746 47.1279H21.0396L21.5571 47.6454V49.1104ZM46.5571 47.6454L47.0746 47.1279H48.5396L49.0571 47.6454V49.1104L48.5396 49.6279H47.0746L46.5571 49.1104V47.6454ZM32.8071 21.6104V20.1454L33.3246 19.6279H34.7896L35.3071 20.1454V21.6104L34.7896 22.1279H33.3246L32.8071 21.6104ZM21.0396 35.8779H19.5746L19.0571 35.3604V33.8954L19.5746 33.3779H21.0396L21.5571 33.8954V35.3604L21.0396 35.8779ZM35.3071 47.6454V49.1104L34.7896 49.6279H33.3246L32.8071 49.1104V47.6454L33.3246 47.1279H34.7896L35.3071 47.6454ZM39.7896 44.6279H28.3246L24.0571 40.3604V28.8954L28.3246 24.6279H39.7896L44.0571 28.8954V40.3604L39.7896 44.6279ZM47.0746 33.3779H48.5396L49.0571 33.8954V35.3604L48.5396 35.8779H47.0746L46.5571 35.3604V33.8954L47.0746 33.3779ZM46.5571 20.1454L47.0746 19.6279H48.5396L49.0571 20.1454V21.6104L48.5396 22.1279H47.0746L46.5571 21.6104V20.1454Z"
        fill="url(#paint1_linear_28_116)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_28_116"
          x1="16.5571"
          y1="20.1279"
          x2="45.0571"
          y2="51.1279"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#413CE3" />
          <stop offset="1" stopColor="#8336ED" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_28_116"
          x1="16.5571"
          y1="20.1279"
          x2="45.0571"
          y2="51.1279"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#413CE3" />
          <stop offset="1" stopColor="#8336ED" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const ExecutableDataIcon = () => {
  return (
    <svg
      className="max-w-[50px] md:max-w-[50px] 3xl:max-w-[67px]"
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.5571 67.6279C52.0587 67.6279 67.0571 52.6295 67.0571 34.1279C67.0571 15.6264 52.0587 0.62793 33.5571 0.62793C15.0556 0.62793 0.0571289 15.6264 0.0571289 34.1279C0.0571289 52.6295 15.0556 67.6279 33.5571 67.6279Z"
        fill="#20187B"
        fillOpacity="0.1"
      />
      <path
        d="M48.824 24.1727C48.824 24.8928 48.4269 25.6058 47.6554 26.271C46.8838 26.9362 45.753 27.5407 44.3273 28.0498C42.9017 28.559 41.2093 28.9629 39.3466 29.2384C37.484 29.514 35.4876 29.6558 33.4715 29.6558C29.3997 29.6558 25.4948 29.0781 22.6156 28.0498C19.7365 27.0216 18.119 25.6269 18.119 24.1727M48.824 24.1727C48.824 23.4527 48.4269 22.7397 47.6554 22.0745C46.8838 21.4092 45.753 20.8048 44.3273 20.2956C42.9017 19.7865 41.2093 19.3826 39.3466 19.1071C37.484 18.8315 35.4876 18.6897 33.4715 18.6897C31.4554 18.6897 29.459 18.8315 27.5963 19.1071C25.7337 19.3826 24.0412 19.7865 22.6156 20.2956C21.19 20.8048 20.0591 21.4092 19.2876 22.0745C18.5161 22.7397 18.119 23.4527 18.119 24.1727M48.824 24.1727L48.8239 43.9117C48.8239 44.8742 48.1146 45.8197 46.7671 46.6532C45.4196 47.4868 43.4816 48.1789 41.1477 48.6602C38.8138 49.1414 36.1663 49.3948 33.4714 49.3948C30.7765 49.3948 28.129 49.1414 25.7952 48.6602C23.4613 48.1789 21.5232 47.4868 20.1757 46.6532C18.8283 45.8197 18.1189 44.8742 18.1189 43.9117L18.119 24.1727M48.8239 37.3321C48.8239 38.2946 48.1146 39.2401 46.7671 40.0737C45.4196 40.9072 43.4816 41.5994 41.1477 42.0806C38.8138 42.5618 36.1663 42.8152 33.4714 42.8152C30.7765 42.8152 28.129 42.5618 25.7952 42.0806C23.4613 41.5994 21.5232 40.9072 20.1757 40.0737C18.8283 39.2401 18.1189 38.2946 18.1189 37.3321M48.8239 30.7523C48.8239 31.7148 48.1146 32.6603 46.7671 33.4939C45.4196 34.3274 43.4816 35.0195 41.1477 35.5008C38.8138 35.982 36.1663 36.2354 33.4714 36.2354C30.7765 36.2354 28.129 35.982 25.7952 35.5008C23.4613 35.0195 21.5232 34.3274 20.1757 33.4939C18.8283 32.6603 18.1189 31.7148 18.1189 30.7523"
        stroke="url(#paint0_linear_28_61)"
        strokeWidth="2.19351"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_28_61"
          x1="9.55713"
          y1="20.6279"
          x2="45.0571"
          y2="52.1279"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#433CE3" />
          <stop offset="1" stopColor="#8136ED" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const DecentralizedFinanceIcon = () => {
  return (
    <svg
      className="max-w-[50px] md:max-w-[50px] 3xl:max-w-[67px]"
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.5571 67.6279C52.0587 67.6279 67.0571 52.6295 67.0571 34.1279C67.0571 15.6264 52.0587 0.62793 33.5571 0.62793C15.0556 0.62793 0.0571289 15.6264 0.0571289 34.1279C0.0571289 52.6295 15.0556 67.6279 33.5571 67.6279Z"
        fill="#20187B"
        fillOpacity="0.1"
      />
      <path
        d="M35.3071 28.3779V27.1279H32.8071V28.3779H32.2896L30.3071 30.3604V33.8954L32.2896 35.8779H34.7896L35.3071 36.3954V37.8604L34.7896 38.3779H33.3246L32.8071 37.8604V37.1279H30.3071V38.8954L32.2896 40.8779H32.8071V42.1279H35.3071V40.8779H35.8246L37.8071 38.8954V35.3604L35.8246 33.3779H33.3246L32.8071 32.8604V31.3954L33.3246 30.8779H34.7896L35.3071 31.3954V32.1279H37.8071V30.3604L35.8246 28.3779H35.3071Z"
        fill="url(#paint0_linear_28_116)"
      />
      <path
        d="M46.0396 24.6279H49.5746L51.5571 22.6454V19.1104L49.5746 17.1279H46.0396L44.0571 19.1104V22.6454L44.1646 22.7529L42.8071 24.1104L40.8246 22.1279H37.8071V19.1104L35.8246 17.1279H32.2896L30.3071 19.1104V22.1279H27.2896L25.3071 24.1104L23.9496 22.7529L24.0571 22.6454V19.1104L22.0746 17.1279H18.5396L16.5571 19.1104V22.6454L18.5396 24.6279H22.0746L22.1821 24.5204L23.5396 25.8779L21.5571 27.8604V30.8779H18.5396L16.5571 32.8604V36.3954L18.5396 38.3779H21.5571V41.3954L23.5396 43.3779L22.1821 44.7354L22.0746 44.6279H18.5396L16.5571 46.6104V50.1454L18.5396 52.1279H22.0746L24.0571 50.1454V46.6104L23.9496 46.5029L25.3071 45.1454L27.2896 47.1279H30.3071V50.1454L32.2896 52.1279H35.8246L37.8071 50.1454V47.1279H40.8246L42.8071 45.1454L44.1646 46.5029L44.0571 46.6104V50.1454L46.0396 52.1279H49.5746L51.5571 50.1454V46.6104L49.5746 44.6279H46.0396L45.9321 44.7354L44.5746 43.3779L46.5571 41.3954V38.3779H49.5746L51.5571 36.3954V32.8604L49.5746 30.8779H46.5571V27.8604L44.5746 25.8779L45.9321 24.5204L46.0396 24.6279ZM21.5571 21.6104L21.0396 22.1279H19.5746L19.0571 21.6104V20.1454L19.5746 19.6279H21.0396L21.5571 20.1454V21.6104ZM21.5571 49.1104L21.0396 49.6279H19.5746L19.0571 49.1104V47.6454L19.5746 47.1279H21.0396L21.5571 47.6454V49.1104ZM46.5571 47.6454L47.0746 47.1279H48.5396L49.0571 47.6454V49.1104L48.5396 49.6279H47.0746L46.5571 49.1104V47.6454ZM32.8071 21.6104V20.1454L33.3246 19.6279H34.7896L35.3071 20.1454V21.6104L34.7896 22.1279H33.3246L32.8071 21.6104ZM21.0396 35.8779H19.5746L19.0571 35.3604V33.8954L19.5746 33.3779H21.0396L21.5571 33.8954V35.3604L21.0396 35.8779ZM35.3071 47.6454V49.1104L34.7896 49.6279H33.3246L32.8071 49.1104V47.6454L33.3246 47.1279H34.7896L35.3071 47.6454ZM39.7896 44.6279H28.3246L24.0571 40.3604V28.8954L28.3246 24.6279H39.7896L44.0571 28.8954V40.3604L39.7896 44.6279ZM47.0746 33.3779H48.5396L49.0571 33.8954V35.3604L48.5396 35.8779H47.0746L46.5571 35.3604V33.8954L47.0746 33.3779ZM46.5571 20.1454L47.0746 19.6279H48.5396L49.0571 20.1454V21.6104L48.5396 22.1279H47.0746L46.5571 21.6104V20.1454Z"
        fill="url(#paint1_linear_28_116)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_28_116"
          x1="16.5571"
          y1="20.1279"
          x2="45.0571"
          y2="51.1279"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#413CE3" />
          <stop offset="1" stopColor="#8336ED" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_28_116"
          x1="16.5571"
          y1="20.1279"
          x2="45.0571"
          y2="51.1279"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#413CE3" />
          <stop offset="1" stopColor="#8336ED" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const TradeFinanceIcon = () => {
  return (
    <svg
      className="max-w-[50px] md:max-w-[50px] 3xl:max-w-[67px]"
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.5571 67.6279C52.0587 67.6279 67.0571 52.6295 67.0571 34.1279C67.0571 15.6264 52.0587 0.62793 33.5571 0.62793C15.0556 0.62793 0.0571289 15.6264 0.0571289 34.1279C0.0571289 52.6295 15.0556 67.6279 33.5571 67.6279Z"
        fill="#20187B"
        fillOpacity="0.1"
      />
      <path
        d="M20.5751 50.1528C20.1575 50.1522 19.7571 49.9861 19.4618 49.6909C19.1666 49.3955 19.0004 48.9952 18.9999 48.5776C18.9953 48.344 18.8993 48.1214 18.7325 47.9578C18.5656 47.7941 18.3412 47.7024 18.1075 47.7024C17.8738 47.7024 17.6494 47.7942 17.4826 47.9578C17.3157 48.1214 17.2197 48.344 17.2152 48.5776C17.2176 49.3109 17.4602 50.0232 17.9058 50.6055C18.3514 51.1877 18.9756 51.608 19.6826 51.8019C19.6209 52.4616 19.7861 53.1435 20.5751 53.1714C21.3601 53.1431 21.5306 52.4647 21.4674 51.8019C22.251 51.5878 22.9302 51.0962 23.3787 50.4188C23.827 49.7413 24.0141 48.9241 23.9049 48.119C23.7958 47.314 23.398 46.576 22.7855 46.0423C22.1729 45.5086 21.3874 45.2155 20.5751 45.2177C20.2634 45.2177 19.9589 45.1252 19.6999 44.9521C19.4409 44.779 19.2389 44.5331 19.1197 44.2452C19.0005 43.9573 18.9694 43.6406 19.0302 43.335C19.091 43.0294 19.241 42.7487 19.4613 42.5285C19.6815 42.3082 19.9623 42.1581 20.2679 42.0973C20.5734 42.0365 20.8901 42.0678 21.178 42.1869C21.4659 42.3061 21.7118 42.5081 21.8851 42.7671C22.0582 43.0261 22.1505 43.3307 22.1505 43.6423C22.1506 43.8789 22.2446 44.1059 22.412 44.2732C22.5794 44.4406 22.8063 44.5346 23.0429 44.5346C23.2797 44.5346 23.5066 44.4406 23.674 44.2732C23.8413 44.1058 23.9354 43.8789 23.9352 43.6421C23.9328 42.9089 23.6902 42.1965 23.2445 41.6143C22.7987 41.032 22.1746 40.6117 21.4674 40.4179C21.5291 39.7583 21.3637 39.0766 20.5751 39.0488C19.7903 39.0771 19.6194 39.7552 19.6828 40.4179C18.906 40.639 18.2351 41.1326 17.793 41.8085C17.3508 42.4841 17.1672 43.2967 17.2756 44.0968C17.3841 44.8971 17.7774 45.6314 18.3834 46.1651C18.9895 46.6988 19.7676 46.996 20.5752 47.0024C20.989 47.0084 21.3839 47.177 21.6744 47.4717C21.965 47.7665 22.1279 48.1638 22.1279 48.5776C22.1279 48.9915 21.965 49.3889 21.6744 49.6835C21.3839 49.9783 20.9888 50.1468 20.5751 50.1528Z"
        fill="url(#paint0_linear_28_92)"
      />
      <path
        d="M20.5751 57.6279C23.6287 57.6245 26.5565 56.41 28.7158 54.2508C30.8752 52.0914 32.0899 49.1638 32.0934 46.1101C31.4604 30.8297 9.68753 30.8338 9.05713 46.1101C9.06057 49.1638 10.2752 52.0914 12.4344 54.2508C14.5937 56.41 17.5213 57.6245 20.5751 57.6279ZM20.5751 36.3765C23.1557 36.3794 25.6298 37.4059 27.4545 39.2306C29.2793 41.0554 30.3057 43.5295 30.3087 46.1101C29.774 59.0223 11.3747 59.019 10.8418 46.11C10.8447 43.5295 11.8711 41.0554 13.6958 39.2307C15.5205 37.406 17.9945 36.3795 20.5751 36.3765Z"
        fill="url(#paint1_linear_28_92)"
      />
      <path
        d="M47.5113 11.6279C44.4577 11.6313 41.53 12.8459 39.3706 15.0052C37.2112 17.1644 35.9965 20.0921 35.9931 23.1458C36.626 38.4263 58.3989 38.4222 59.0293 23.1457C59.0259 20.092 57.8113 17.1644 55.652 15.0052C53.4926 12.8459 50.565 11.6313 47.5113 11.6279ZM57.1994 22.2535H52.846C52.8586 19.3847 52.1713 16.5562 50.844 14.0129C52.5738 14.6455 54.0889 15.7554 55.2137 17.2138C56.3385 18.6723 57.027 20.4197 57.1994 22.2535ZM47.5113 32.8794C45.9179 32.8794 44.1483 29.1546 43.9607 24.0382H51.0621C50.8745 29.1546 49.1049 32.8794 47.5113 32.8794ZM43.9607 22.2535C44.1484 17.1374 45.9179 13.4126 47.5113 13.4126C49.1049 13.4126 50.8743 17.1374 51.0621 22.2535H43.9607ZM44.1789 14.0127C42.8515 16.556 42.1642 19.3846 42.1768 22.2535H37.823C37.9953 20.4196 38.6839 18.6721 39.8088 17.2136C40.9338 15.7551 42.449 14.6453 44.1789 14.0127ZM37.823 24.0382H42.1768C42.1642 26.9071 42.8515 29.7359 44.179 32.2792C42.449 31.6466 40.9338 30.5368 39.8088 29.0783C38.6839 27.6196 37.9953 25.872 37.823 24.0382ZM50.8439 32.2792C52.1713 29.7357 52.8586 26.9071 52.846 24.0382H57.1994C57.0271 25.872 56.3386 27.6195 55.2138 29.078C54.0889 30.5366 52.5738 31.6465 50.8439 32.2792Z"
        fill="url(#paint2_linear_28_92)"
      />
      <path
        d="M45.6578 46.074H36.6536C36.4193 46.0776 36.1959 46.1732 36.0315 46.3402C35.8671 46.5072 35.775 46.7321 35.775 46.9664C35.775 47.2007 35.8672 47.4256 36.0316 47.5926C36.1959 47.7594 36.4194 47.855 36.6537 47.8587H45.6578C46.3858 47.8579 47.0838 47.5684 47.5986 47.0536C48.1133 46.5387 48.4029 45.8408 48.4038 45.1127V40.8951L48.9367 41.428C49.1039 41.5952 49.331 41.6892 49.5676 41.6892C49.8042 41.6892 50.0311 41.5952 50.1985 41.4279C50.3658 41.2606 50.4599 41.0337 50.4599 40.7969C50.4599 40.5603 50.3658 40.3334 50.1985 40.166L48.1425 38.1101C47.9728 37.9456 47.7453 37.8541 47.509 37.8549C47.2725 37.8557 47.0459 37.9488 46.8773 38.1146C46.0611 38.9467 45.1306 39.8922 44.9258 40.078C44.7745 40.1895 44.6622 40.3459 44.6048 40.525C44.5475 40.7039 44.5484 40.8966 44.607 41.0751C44.6656 41.2538 44.7791 41.4094 44.9314 41.5196C45.0837 41.6299 45.2669 41.6892 45.4548 41.6893C45.7495 41.6893 45.848 41.6815 46.619 40.9202V45.1127C46.6188 45.3676 46.5173 45.6119 46.3372 45.7921C46.157 45.9723 45.9126 46.0737 45.6578 46.074Z"
        fill="url(#paint3_linear_28_92)"
      />
      <path
        d="M22.4081 23.1057H31.4123C31.6467 23.1023 31.8703 23.0067 32.0348 22.8397C32.1993 22.6727 32.2915 22.4477 32.2915 22.2134C32.2915 21.979 32.1993 21.7539 32.0348 21.5869C31.8703 21.42 31.6466 21.3245 31.4123 21.321H22.4081C21.6802 21.3218 20.9822 21.6113 20.4675 22.126C19.9527 22.6406 19.6631 23.3385 19.6622 24.0665V28.2844L19.1293 27.7514C19.0465 27.6683 18.9481 27.6022 18.8398 27.5572C18.7315 27.5122 18.6153 27.4888 18.498 27.4888C18.3806 27.4887 18.2645 27.5117 18.156 27.5565C18.0476 27.6014 17.9491 27.6671 17.8661 27.75C17.7832 27.8331 17.7174 27.9316 17.6725 28.0399C17.6277 28.1485 17.6047 28.2646 17.6048 28.3819C17.6049 28.4993 17.6282 28.6154 17.6732 28.7238C17.7183 28.832 17.7843 28.9305 17.8674 29.0133L19.9233 31.0695C20.0932 31.2339 20.3205 31.3256 20.557 31.3248C20.7933 31.3238 21.02 31.2307 21.1887 31.0651C22.0047 30.2326 22.9352 29.287 23.14 29.1009C23.2915 28.9893 23.4038 28.833 23.4609 28.654C23.5182 28.4749 23.5175 28.2824 23.4589 28.1039C23.4003 27.9253 23.2867 27.7699 23.1344 27.6596C22.9823 27.5493 22.7991 27.49 22.6112 27.49C22.3165 27.49 22.2178 27.4978 21.447 28.2593V24.0665C21.4472 23.8117 21.5487 23.5675 21.7288 23.3874C21.909 23.2073 22.1534 23.106 22.4081 23.1057Z"
        fill="url(#paint4_linear_28_92)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_28_92"
          x1="19.7654"
          y1="29.8687"
          x2="51.7204"
          y2="57.7443"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#423CE3" />
          <stop offset="1" stopColor="#8136ED" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_28_92"
          x1="19.7654"
          y1="29.8687"
          x2="51.7204"
          y2="57.7443"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#423CE3" />
          <stop offset="1" stopColor="#8136ED" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_28_92"
          x1="19.7654"
          y1="29.8687"
          x2="51.7204"
          y2="57.7443"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#423CE3" />
          <stop offset="1" stopColor="#8136ED" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_28_92"
          x1="19.7654"
          y1="29.8687"
          x2="51.7204"
          y2="57.7443"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#423CE3" />
          <stop offset="1" stopColor="#8136ED" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_28_92"
          x1="19.7654"
          y1="29.8687"
          x2="51.7204"
          y2="57.7443"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#423CE3" />
          <stop offset="1" stopColor="#8136ED" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const CurrencyIcon = () => {
  return (
    <svg
      className="max-w-[50px] md:max-w-[50px] 3xl:max-w-[67px]"
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.5571 67.6279C52.0587 67.6279 67.0571 52.6295 67.0571 34.1279C67.0571 15.6264 52.0587 0.62793 33.5571 0.62793C15.0556 0.62793 0.0571289 15.6264 0.0571289 34.1279C0.0571289 52.6295 15.0556 67.6279 33.5571 67.6279Z"
        fill="#20187B"
        fillOpacity="0.1"
      />
      <path
        d="M33.8163 38.9527H33.9131C35.9878 39.008 37.6475 40.6954 37.6475 42.7701C37.6475 44.5405 36.4442 46.0204 34.8121 46.463V48.0121C34.8121 48.5653 34.3695 49.0079 33.8163 49.0079C33.263 49.0079 32.8204 48.5653 32.8204 48.0121V46.463C32.0077 46.2445 31.2896 45.7644 30.7772 45.0969C30.2647 44.4294 29.9863 43.6117 29.9851 42.7701C29.9851 42.2169 30.4276 41.7743 30.9809 41.7743C31.5341 41.7743 31.9767 42.2169 31.9767 42.7701C31.9767 43.7936 32.7928 44.6096 33.8024 44.6096C34.8121 44.6096 35.642 43.7798 35.642 42.7701C35.642 41.7604 34.8121 40.9306 33.8024 40.9306H33.7056C32.7106 40.9036 31.7654 40.4898 31.0707 39.7769C30.3759 39.0641 29.9864 38.1086 29.9851 37.1132C29.9851 35.3428 31.1884 33.8629 32.8204 33.4203V31.8712C32.8204 31.3179 33.263 30.8754 33.8163 30.8754C34.3695 30.8754 34.8121 31.3179 34.8121 31.8712V33.4203C36.4442 33.8629 37.6475 35.3428 37.6475 37.1132C37.6475 37.6664 37.2049 38.109 36.6516 38.109C36.0984 38.109 35.6558 37.6664 35.6558 37.1132C35.6558 36.1035 34.8259 35.2736 33.8163 35.2736C32.8066 35.2736 31.9767 36.1035 31.9767 37.1132C31.9767 38.1229 32.8066 38.9527 33.8163 38.9527Z"
        fill="url(#paint0_linear_28_76)"
      />
      <path
        d="M26.4747 19.2503L30.3281 23.7592L29.9117 24.224C21.981 26.0027 16.0571 33.0856 16.0571 41.553C16.0571 48.9969 22.0986 55.0383 29.5425 55.0383H38.0763C45.5202 55.0383 51.5616 48.9983 51.5616 41.5543C51.5754 33.0856 45.6516 26.0027 37.7208 24.224C37.753 23.9317 37.7002 23.6363 37.5686 23.3734L40.8466 19.621L41.0582 19.2946C41.3054 18.7556 41.3686 18.1504 41.2382 17.572C41.1078 16.9936 40.7909 16.4741 40.3364 16.0933C39.882 15.7125 39.315 15.4916 38.7227 15.4645C38.1305 15.4374 37.5457 15.6056 37.0583 15.9433L35.8923 14.5602C35.6308 14.2675 35.3104 14.0332 34.9524 13.8726C34.5941 13.7119 34.2062 13.6286 33.8136 13.6279C33.4211 13.6273 33.0329 13.7093 32.6742 13.8688C32.3155 14.0282 31.9944 14.2614 31.7319 14.5533L30.5106 15.917C30.0245 15.5723 29.4384 15.3974 28.8429 15.4193C28.2475 15.4412 27.6757 15.6587 27.2162 16.0382C26.7567 16.4177 26.4352 16.9379 26.3011 17.5186C26.1671 18.0992 26.2281 18.7078 26.4747 19.2503ZM31.7292 21.1659L29.3834 18.455C29.9283 18.7176 30.5449 18.7922 31.1369 18.667C31.7287 18.5419 32.2623 18.2242 32.6545 17.7635L33.7609 16.3278L34.9891 17.7828C35.3721 18.2282 35.8887 18.5378 36.4619 18.6657C37.0352 18.7936 37.6343 18.7328 38.1703 18.4924L35.8356 21.1659H31.7292ZM18.8234 41.553C18.8234 33.2709 25.5342 26.56 33.8163 26.56C42.0983 26.56 48.8092 33.2709 48.7954 41.5502V41.553C48.7943 44.3955 47.6645 47.1214 45.6546 49.1313C43.6447 51.1412 40.9188 52.271 38.0763 52.2721H29.5425C26.6999 52.271 23.9741 51.1412 21.9641 49.1313C19.9541 47.1214 18.8245 44.3955 18.8234 41.553Z"
        fill="url(#paint1_linear_28_76)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_28_76"
          x1="19.5149"
          y1="20.5435"
          x2="42.3362"
          y2="59.2706"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#423CE3" />
          <stop offset="1" stopColor="#8436ED" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_28_76"
          x1="19.5149"
          y1="20.5435"
          x2="42.3362"
          y2="59.2706"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#423CE3" />
          <stop offset="1" stopColor="#8436ED" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const FarmingIcon = () => {
  return (
    <svg
      className="max-w-[50px] md:max-w-[55px] 3xl:max-w-[67px]"
      width="67"
      height="67"
      viewBox="0 0 67 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.844224"
        y="0.844224"
        width="65.3116"
        height="65.3116"
        rx="32.6558"
        fill="white"
      />
      <rect
        x="0.844224"
        y="0.844224"
        width="65.3116"
        height="65.3116"
        rx="32.6558"
        stroke="#463CE4"
        strokeWidth="1.68845"
      />
      <path
        d="M46.0564 11C44.7598 11.2158 43.5115 11.2903 42.4858 11.5138C41.0536 11.8215 40.1441 12.2483 39.6022 13.6823C39.4667 14.0578 39.5054 14.2629 39.6409 14.5155C39.7763 14.769 40.0763 15.0497 40.4634 15.2703C40.8504 15.4919 41.3149 15.6506 41.7117 15.7173C42.0987 15.7841 42.4374 15.7173 42.4374 15.7173H42.4471C44.1792 14.9277 45.3694 13.0243 46.0564 11ZM39.0216 16.3976C38.6926 18.3426 37.7152 20.1289 36.5831 21.8416C36.5444 22.0545 36.496 22.2577 36.4379 22.4609C36.1766 23.3609 35.7122 24.2221 35.0542 24.9575L35.0638 24.9672C35.8089 24.3963 36.5637 24.0479 37.3088 23.8737C38.6926 21.9191 40.0957 19.7418 40.6376 17.2433C40.2795 17.1282 39.9312 16.9763 39.5925 16.7837C39.399 16.6705 39.2054 16.5418 39.0216 16.3976ZM30.7287 17.2308C29.5772 17.2211 28.2612 17.4494 26.8194 17.8113C24.5454 18.3813 22.0779 19.2386 19.7071 19.7418C21.4682 21.3675 22.8326 23.0802 24.2744 24.2318C26.1033 25.6833 27.9322 26.3993 31.3964 25.3155C33.1672 24.764 34.3575 23.4093 34.7639 21.9771C35.18 20.545 34.8703 19.0935 33.5736 18.0658C32.8382 17.4843 31.8706 17.2404 30.7287 17.2308ZM38.5861 25.393C37.7443 25.3833 36.9024 25.6833 35.896 26.5348C33.6124 28.4604 34.6671 30.4732 35.6831 30.928H35.6928C35.9251 31.0344 36.525 31.0731 37.2895 30.9086C38.0636 30.7441 38.9925 30.3958 39.9505 29.9313C41.3536 29.2539 42.7954 28.3153 43.9082 27.3767C42.6309 26.8928 41.4794 26.1961 40.386 25.7994C39.815 25.5865 39.2828 25.4317 38.7506 25.4026C38.6926 25.4026 38.6345 25.393 38.5861 25.393ZM32.577 31.6634C27.9322 31.7118 23.7422 32.1085 20.7038 32.6891C19.0684 32.9988 17.7515 33.3761 16.9202 33.7535C16.5042 33.9374 16.2129 34.1309 16.0735 34.2664C16.0232 34.3148 16.0135 34.3244 16 34.3438C16.0135 34.3632 16.0232 34.3728 16.0735 34.4212C16.2129 34.5567 16.5042 34.7502 16.9202 34.9341C17.7515 35.3115 19.0684 35.6888 20.7038 35.9985C23.9842 36.6275 28.5902 37.0242 33.6801 37.0242C38.77 37.0242 43.376 36.6275 46.6564 35.9985C48.2917 35.6888 49.6077 35.3115 50.4399 34.9341C50.856 34.7502 51.1463 34.5567 51.2915 34.4212C51.3399 34.3728 51.3495 34.3632 51.3592 34.3438C51.3495 34.3244 51.3399 34.3148 51.2915 34.2664C51.1463 34.1309 50.856 33.9374 50.4399 33.7535C49.6077 33.3761 48.2917 32.9988 46.6564 32.6891C44.7888 32.3311 42.4858 32.0504 39.9118 31.8666C39.1377 32.1956 38.3829 32.4569 37.6572 32.6117C36.6992 32.8149 35.7993 32.8826 34.9768 32.5149C34.7639 32.4182 34.5607 32.302 34.3768 32.1666C34.4639 33.0181 34.5703 33.8696 34.6865 34.7309L32.964 34.9825C32.7995 33.8793 32.664 32.7859 32.577 31.6634ZM16.6812 36.7242L17.4447 40.5368C18.4317 41.3787 20.6361 42.2205 23.4423 42.7624C26.413 43.3237 30.0514 43.614 33.6801 43.614C37.3088 43.614 40.9472 43.3237 43.9179 42.7624C46.7241 42.2205 48.9304 41.3787 49.9174 40.5368L50.6819 36.7242C49.6948 37.1016 48.4466 37.4306 46.9854 37.7113C43.5405 38.3693 38.8571 38.766 33.6801 38.766C28.5031 38.766 23.8196 38.3693 20.3748 37.7113C18.9136 37.4306 17.6673 37.1016 16.6812 36.7242ZM20.9941 44.001L22.1262 53.039C22.7552 53.8228 24.2454 54.6356 26.2581 55.1581C28.387 55.7097 31.0287 56 33.6801 56C36.3315 56 38.9732 55.7097 41.102 55.1581C43.1148 54.6356 44.605 53.8228 45.2339 53.039L46.3661 44.001C45.6984 44.1752 44.992 44.3204 44.2469 44.4655C41.1214 45.0655 37.4056 45.3558 33.6801 45.3558C29.9546 45.3558 26.2388 45.0655 23.1133 44.4655C22.3682 44.33 21.6618 44.1752 20.9941 44.001Z"
        fill="url(#paint0_linear_43_769)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_43_769"
          x1="16"
          y1="16"
          x2="40"
          y2="53"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#433CE3" />
          <stop offset="1" stopColor="#8835EE" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const VestingIcon = () => {
  return (
    <svg
      className="max-w-[50px] md:max-w-[55px] 3xl:max-w-[67px]"
      width="67"
      height="67"
      viewBox="0 0 67 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.844224"
        y="0.844224"
        width="65.3116"
        height="65.3116"
        rx="32.6558"
        fill="white"
      />
      <rect
        x="0.844224"
        y="0.844224"
        width="65.3116"
        height="65.3116"
        rx="32.6558"
        stroke="#463CE4"
        strokeWidth="1.68845"
      />
      <path
        d="M48.6 22.4C48.6 18.3892 41.8235 15 33.8 15C25.7766 15 19 18.3892 19 22.4V26.1C19 30.1108 25.7766 33.5 33.8 33.5C41.8235 33.5 48.6 30.1108 48.6 26.1V22.4ZM33.8 46.45C25.7766 46.45 19 43.0608 19 39.05V44.6C19 48.6108 25.7766 52 33.8 52C41.8235 52 48.6 48.6108 48.6 44.6V39.05C48.6 43.0608 41.8235 46.45 33.8 46.45Z"
        fill="url(#paint0_linear_43_781)"
      />
      <path
        d="M48.6 29.8001C48.6 33.8109 41.8235 37.2001 33.8 37.2001C25.7766 37.2001 19 33.8109 19 29.8001V35.3501C19 39.3609 25.7766 42.7501 33.8 42.7501C41.8235 42.7501 48.6 39.3609 48.6 35.3501V29.8001Z"
        fill="url(#paint1_linear_43_781)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_43_781"
          x1="22.5"
          y1="29"
          x2="41"
          y2="59.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#413CE3" />
          <stop offset="1" stopColor="#8B35EE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_43_781"
          x1="22.5"
          y1="29"
          x2="41"
          y2="59.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#413CE3" />
          <stop offset="1" stopColor="#8B35EE" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const SalesIcon = () => {
  return (
    <svg
      className="max-w-[50px] md:max-w-[55px] 3xl:max-w-[67px]"
      width="67"
      height="67"
      viewBox="0 0 67 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.844224"
        y="0.844224"
        width="65.3116"
        height="65.3116"
        rx="32.6558"
        fill="white"
      />
      <rect
        x="0.844224"
        y="0.844224"
        width="65.3116"
        height="65.3116"
        rx="32.6558"
        stroke="#463CE4"
        strokeWidth="1.68845"
      />
      <mask
        id="mask0_43_789"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="15"
        y="13"
        width="37"
        height="42"
      >
        <path
          d="M49.3 24.5L33.15 15L17 24.5V43.5L33.15 53L49.3 43.5V24.5Z"
          fill="white"
          stroke="white"
          strokeWidth="3.8"
          strokeLinejoin="round"
        />
        <path
          d="M33.15 32.1V39.7M40.75 28.3V39.7M25.55 35.9V39.7"
          stroke="black"
          strokeWidth="3.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#mask0_43_789)">
        <path
          d="M10.3501 11.2H55.9501V56.7999H10.3501V11.2Z"
          fill="url(#paint0_linear_43_789)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_43_789"
          x1="10"
          y1="17"
          x2="39"
          y2="57"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#423CE3" />
          <stop offset="1" stopColor="#8735EE" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const TokenIcon = () => {
  return (
    <svg
      className="max-w-[50px] md:max-w-[55px] 3xl:max-w-[67px]"
      width="67"
      height="67"
      viewBox="0 0 67 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.844224"
        y="0.844224"
        width="65.3116"
        height="65.3116"
        rx="32.6558"
        fill="white"
      />
      <rect
        x="0.844224"
        y="0.844224"
        width="65.3116"
        height="65.3116"
        rx="32.6558"
        stroke="#463CE4"
        strokeWidth="1.68845"
      />
      <path
        d="M27.4068 28.1864C28.1525 27.4068 29.0258 26.7878 30.0264 26.3295C31.0271 25.8712 32.12 25.6427 33.3051 25.6441C34.4915 25.6441 35.5851 25.8732 36.5858 26.3315C37.5864 26.7898 38.459 27.4081 39.2034 28.1864L49.4746 22.4407L35.2881 14.5593C34.678 14.1864 34.0169 14 33.3051 14C32.5932 14 31.9322 14.1864 31.322 14.5593L17.1356 22.4407L27.4068 28.1864ZM31.2712 53V41.661C29.5085 41.1864 28.0508 40.2291 26.8983 38.7892C25.7458 37.3491 25.1695 35.6793 25.1695 33.7797C25.1695 33.4068 25.1864 33.0508 25.2203 32.7119C25.2542 32.3729 25.322 32.0508 25.4237 31.7458L15 25.8983V41.5593C15 42.3051 15.1864 42.9919 15.5593 43.6197C15.9322 44.2475 16.4407 44.7471 17.0847 45.1186L31.2712 53ZM33.3051 37.8475C34.4237 37.8475 35.3817 37.4495 36.179 36.6536C36.9763 35.8576 37.3742 34.8997 37.3729 33.7797C37.3729 32.661 36.9749 31.7037 36.179 30.9078C35.3831 30.1119 34.4251 29.7132 33.3051 29.7119C32.1864 29.7119 31.2292 30.1105 30.4332 30.9078C29.6373 31.7051 29.2386 32.6624 29.2373 33.7797C29.2373 34.8983 29.6359 35.8563 30.4332 36.6536C31.2305 37.4508 32.1878 37.8488 33.3051 37.8475ZM35.339 53L49.5254 45.1186C50.1695 44.7458 50.678 44.2461 51.0508 43.6197C51.4237 42.9932 51.6102 42.3064 51.6102 41.5593V25.8983L41.1864 31.7458C41.2881 32.0847 41.3559 32.4156 41.3898 32.7383C41.4237 33.061 41.4407 33.4081 41.4407 33.7797C41.4407 35.678 40.8644 37.3478 39.7119 38.7892C38.5593 40.2305 37.1017 41.1878 35.339 41.661V53Z"
        fill="url(#paint0_linear_43_799)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_43_799"
          x1="15"
          y1="25.5"
          x2="42.5"
          y2="58.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#413CE3" />
          <stop offset="1" stopColor="#8835EE" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const Linkdin = () => {
  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_43_3853)">
<path d="M26.146 0.751953H8.61475C4.34317 0.751953 0.880371 4.21475 0.880371 8.48633V26.0176C0.880371 30.2892 4.34317 33.752 8.61475 33.752H26.146C30.4176 33.752 33.8804 30.2892 33.8804 26.0176V8.48633C33.8804 4.21475 30.4176 0.751953 26.146 0.751953Z" fill="white"/>
<path d="M26.146 0.751953H8.61475C4.34317 0.751953 0.880371 4.21475 0.880371 8.48633V26.0176C0.880371 30.2892 4.34317 33.752 8.61475 33.752H26.146C30.4176 33.752 33.8804 30.2892 33.8804 26.0176V8.48633C33.8804 4.21475 30.4176 0.751953 26.146 0.751953Z" fill="#0A66C2"/>
<path d="M24.6913 28.8129H28.4644C28.6011 28.8129 28.7322 28.7586 28.8289 28.6619C28.9256 28.5653 28.98 28.4341 28.98 28.2974L28.9819 20.3256C28.9819 16.159 28.0841 12.9563 23.2149 12.9563C21.364 12.8874 19.6184 13.8416 18.6765 15.4349C18.6719 15.4426 18.6649 15.4486 18.6566 15.452C18.6482 15.4554 18.639 15.456 18.6303 15.4536C18.6216 15.4513 18.6139 15.4461 18.6084 15.439C18.6029 15.4319 18.5999 15.4231 18.5998 15.4141V13.8566C18.5998 13.7198 18.5455 13.5887 18.4488 13.492C18.3521 13.3953 18.221 13.3409 18.0842 13.3409H14.5036C14.3668 13.3409 14.2357 13.3953 14.139 13.492C14.0423 13.5887 13.9879 13.7198 13.9879 13.8566V28.2966C13.9879 28.4334 14.0423 28.5645 14.139 28.6612C14.2357 28.7579 14.3668 28.8123 14.5036 28.8123H18.2764C18.4132 28.8123 18.5443 28.7579 18.641 28.6612C18.7377 28.5645 18.792 28.4334 18.792 28.2966V21.1587C18.792 19.1404 19.1749 17.1858 21.6771 17.1858C24.1437 17.1858 24.1757 19.4953 24.1757 21.2894V28.2973C24.1757 28.434 24.23 28.5652 24.3267 28.6619C24.4234 28.7586 24.5545 28.8129 24.6913 28.8129ZM5.77881 8.43837C5.77881 9.96772 7.03784 11.2261 8.56731 11.2261C10.0964 11.226 11.3546 9.96682 11.3546 8.43773C11.3544 6.90864 10.096 5.65039 8.56679 5.65039C7.03719 5.65039 5.77881 6.90903 5.77881 8.43837ZM6.67587 28.8129H10.4537C10.5905 28.8129 10.7216 28.7586 10.8183 28.6619C10.915 28.5652 10.9693 28.434 10.9693 28.2973V13.8566C10.9693 13.7198 10.915 13.5887 10.8183 13.492C10.7216 13.3953 10.5905 13.3409 10.4537 13.3409H6.67587C6.53911 13.3409 6.40796 13.3953 6.31127 13.492C6.21457 13.5887 6.16024 13.7198 6.16024 13.8566V28.2973C6.16024 28.434 6.21457 28.5652 6.31127 28.6619C6.40796 28.7586 6.53911 28.8129 6.67587 28.8129Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_43_3853">
<rect width="33" height="33" fill="white" transform="translate(0.880371 0.751953)"/>
</clipPath>
</defs>
</svg>
  );
};
export const Arrow = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="20" viewBox="0 0 23 20" fill="none">
    <path d="M11.2999 18.2998L19.5999 9.9998L11.2999 1.69981L12.6999 0.299805L22.3999 9.9998L12.6999 19.6998L11.2999 18.2998Z" fill="white"/>
    <path d="M21 9V11H0V9H21Z" fill="white"/>
  </svg>
  );
};
export const RoadmapIcon = () => {
  return (
    <svg width="39" height="93" viewBox="0 0 39 93" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
    <rect x="1.51359" y="0.935102" width="36.1209" height="36.1209" rx="18.0605" stroke="#20187B" strokeWidth="1.58773"/>
    <circle cx="19.574" cy="18.9956" r="9.92333" fill="#20187B"/>
    </g>
    <path d="M19.0776 92.4283L23.661 84.4897H14.4942L19.0776 92.4283ZM18.2838 36.8577V85.2835H19.8715V36.8577H18.2838Z" fill="#20187B"/>
    </svg>
  );
};
export const RoadmapIconSingle = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="39" height="38" viewBox="0 0 39 38" fill="none">
    <g>
      <rect x="1.51335" y="0.943769" width="36.1209" height="36.1209" rx="18.0605" stroke="#20187B" strokeWidth="1.58773"/>
      <circle cx="19.574" cy="19.0044" r="9.92333" fill="#20187B"/>
    </g>
  </svg>
  );
};
export const PieChart = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="172" height="172" viewBox="0 0 172 172" fill="none">
  <path d="M160.242 129.406C149.561 147.675 132.519 161.365 112.377 167.855C92.2344 174.346 70.4061 173.182 51.0682 164.586C31.7303 155.99 16.2407 140.566 7.56293 121.265C-1.11484 101.964 -2.37143 80.1407 4.03359 59.971C10.4386 39.8013 24.0555 22.7013 42.2789 11.9428C60.5024 1.18424 82.0528 -2.47746 102.807 1.65829C123.561 5.79404 142.062 17.4368 154.769 34.3591C167.477 51.2813 173.499 72.2948 171.683 93.379L150.804 91.5809C152.178 75.6343 147.623 59.7412 138.012 46.9424C128.401 34.1437 114.409 25.3379 98.7116 22.2099C83.0146 19.0819 66.7154 21.8513 52.9325 29.9884C39.1496 38.1254 28.8507 51.0586 24.0064 66.3135C19.1621 81.5684 20.1125 98.0739 26.6757 112.672C33.239 127.27 44.9543 138.936 59.5801 145.437C74.2059 151.938 90.7152 152.818 105.949 147.909C121.184 143 134.073 132.647 142.152 118.829L160.242 129.406Z" fill="#12D8E5"/>
  <path d="M160.242 129.406C149.966 146.983 133.787 160.343 114.585 167.11C95.3826 173.878 74.402 173.613 55.3766 166.363C36.3512 159.113 20.515 145.348 10.6858 127.518C0.856595 109.688 -2.32797 88.949 1.69874 68.9912C5.72546 49.0335 16.7023 31.1516 32.676 18.5274C48.6497 5.90332 68.5841 -0.644183 88.9322 0.0500026C109.28 0.744188 128.722 8.63503 143.798 22.3184C158.875 36.0018 168.607 54.5902 171.264 74.776L150.488 77.511C148.478 62.2439 141.117 48.1849 129.715 37.8358C118.312 27.4866 103.608 21.5185 88.2177 20.9935C72.8279 20.4685 57.7508 25.4205 45.6695 34.9685C33.5881 44.5165 25.286 58.0411 22.2405 73.1358C19.195 88.2304 21.6035 103.916 29.0376 117.401C36.4717 130.887 48.4492 141.298 62.8386 146.781C77.2281 152.264 93.0963 152.465 107.62 147.346C122.143 142.228 134.379 132.123 142.152 118.829L160.242 129.406Z" fill="#110DD8"/>
  <path d="M160.242 129.406C150.915 145.359 136.698 157.883 119.697 165.124C102.695 172.364 83.8138 173.936 65.8492 169.606C47.8846 165.276 31.7925 155.275 19.9564 141.084C8.1204 126.893 1.17008 109.267 0.135016 90.8171C-0.900048 72.3671 4.0352 54.0744 14.2097 38.6486C24.3842 23.2229 39.2568 11.4846 56.6244 5.17258C73.9919 -1.13943 92.9307 -1.68945 110.635 3.60401C128.34 8.89746 143.869 19.7528 154.921 34.5621L138.127 47.096C129.768 35.8953 118.023 27.6851 104.632 23.6815C91.2419 19.6779 76.9179 20.0939 63.7823 24.8678C50.6467 29.6418 39.3982 38.5198 31.7029 50.1868C24.0076 61.8537 20.2749 75.689 21.0578 89.6433C21.8406 103.598 27.0974 116.929 36.0493 127.662C45.0012 138.395 57.1722 145.959 70.7594 149.234C84.3465 152.508 98.6272 151.32 111.486 145.843C124.345 140.367 135.097 130.895 142.152 118.829L160.242 129.406Z" fill="#3FB4F6"/>
  <path d="M94.2513 171.603C82.6683 172.72 70.9792 171.474 59.8917 167.941C48.8042 164.408 38.549 158.662 29.747 151.051C20.9449 143.439 13.7792 134.12 8.68358 123.659C3.58798 113.197 0.668525 101.81 0.101984 90.187C-0.464558 78.5641 1.3336 66.9471 5.38758 56.0394C9.44156 45.1317 15.667 35.1602 23.6871 26.7286C31.7071 18.297 41.3549 11.5808 52.0462 6.98646C62.7376 2.39216 74.2501 0.0153946 85.8868 7.45304e-05L85.9144 20.9557C77.1132 20.9673 68.4059 22.7649 60.3197 26.2397C52.2336 29.7145 44.9367 34.7943 38.8709 41.1713C32.8051 47.5484 28.0966 55.0901 25.0305 63.3399C21.9643 71.5897 20.6043 80.376 21.0328 89.1667C21.4613 97.9575 23.6694 106.57 27.5233 114.482C31.3773 122.395 36.7969 129.443 43.4542 135.2C50.1114 140.957 57.8677 145.303 66.2535 147.975C74.6393 150.646 83.4801 151.589 92.2407 150.744L94.2513 171.603Z" fill="#C61AF1"/>
  <path d="M171.625 94.0188C170.485 106.194 166.761 117.987 160.703 128.609C154.644 139.231 146.389 148.439 136.49 155.619C126.59 162.798 115.273 167.784 103.294 170.243C91.3155 172.702 78.9498 172.579 67.0224 169.88C55.0951 167.181 43.8804 161.97 34.1266 154.594C24.3729 147.218 16.3043 137.846 10.4594 127.105C4.61446 116.363 1.12754 104.499 0.231284 92.303C-0.664968 80.107 1.05006 67.8602 5.26194 56.3796L24.9354 63.5973C21.7499 72.2803 20.4527 81.543 21.1306 90.7671C21.8085 99.9912 24.4457 108.965 28.8664 117.089C33.2871 125.213 39.3896 132.301 46.7666 137.88C54.1437 143.459 62.6257 147.4 71.6467 149.441C80.6677 151.482 90.0203 151.576 99.0803 149.716C108.14 147.856 116.7 144.085 124.187 138.655C131.674 133.225 137.917 126.26 142.5 118.226C147.082 110.192 149.899 101.274 150.761 92.0649L171.625 94.0188Z" fill="#753FF6"/>
</svg>
  );
};
export const Telegram = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
    <circle cx="20.6687" cy="21.028" r="19.9305" stroke="#4E3BE4" strokeWidth="1.47633"/>
    <path d="M30.3762 10.233L8.80039 18.5961C7.93214 18.9856 7.63847 19.7655 8.59053 20.1888L14.1257 21.9569L27.5089 13.643C28.2397 13.1211 28.9878 13.2603 28.344 13.8345L16.8496 24.2957L16.4886 28.7228C16.823 29.4064 17.4353 29.4096 17.8259 29.0698L21.006 26.0452L26.4525 30.1447C27.7175 30.8974 28.4058 30.4117 28.6779 29.0319L32.2503 12.0289C32.6212 10.3306 31.9887 9.58228 30.3762 10.233Z" fill="url(#paint0_linear_43_4126)"/>
    <defs>
      <linearGradient id="paint0_linear_43_4126" x1="12.5" y1="13" x2="26" y2="30" gradientUnits="userSpaceOnUse">
        <stop stopColor="#5A39E6"/>
        <stop offset="1" stopColor="#7237EA"/>
      </linearGradient>
    </defs>
  </svg>
  );
};
 
export const TeamKycIcon = () => {
  return (
    <svg className=" max-[400px]:w-[40px]" xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58" fill="none">
    <rect x="1.80727" y="1.87344" width="54.5783" height="54.5783" rx="27.2892" stroke="#463CE4" strokeWidth="1.98467"/>
    <path d="M40.973 14.6899L31.3359 11.0804C30.3372 10.7125 28.7077 10.7125 27.7089 11.0804L18.0719 14.6899C16.2145 15.3908 14.7076 17.5635 14.7076 19.5435V33.7363C14.7076 35.1555 15.6363 37.0304 16.7752 37.8714L26.4123 45.0729C28.1119 46.352 30.8979 46.352 32.5975 45.0729L42.2346 37.8714C43.3735 37.0129 44.3022 35.1555 44.3022 33.7363V19.5435C44.3197 17.5635 42.8128 15.3908 40.973 14.6899ZM35.6113 24.5022L28.0769 32.0366C27.814 32.2995 27.4811 32.4221 27.1482 32.4221C26.8153 32.4221 26.4824 32.2995 26.2195 32.0366L23.416 29.1981C22.9079 28.6899 22.9079 27.8489 23.416 27.3408C23.9242 26.8326 24.7652 26.8326 25.2734 27.3408L27.1657 29.2331L33.7715 22.6274C34.2796 22.1192 35.1207 22.1192 35.6288 22.6274C36.137 23.1355 36.137 23.9941 35.6113 24.5022Z" fill="url(#paint0_linear_31_362)"/>
    <defs>
      <linearGradient id="paint0_linear_31_362" x1="14.7076" y1="18.7147" x2="44.0223" y2="50.8213" gradientUnits="userSpaceOnUse">
        <stop stopColor="#423CE3"/>
        <stop offset="1" stopColor="#8635ED"/>
      </linearGradient>
    </defs>
  </svg>
  );
};
export const SmartContractIcon = () => {
  return (
    <svg className=" max-[400px]:w-[40px]" width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.51199" y="1.67349" width="54.9782" height="54.9782" rx="27.4891" stroke="#463CE4" strokeWidth="1.58477"/>
    <g clip-path="url(#clip0_31_379)">
    <path d="M21.5234 14.7516C19.4474 14.7516 17.7595 16.4394 17.7595 18.5154V41.0984C17.7595 43.1744 19.4474 44.8622 21.5234 44.8622H36.5787C38.6547 44.8622 40.3425 43.1744 40.3425 41.0984V24.1612H32.8148C31.7739 24.1612 30.9329 23.3202 30.9329 22.2792V14.7516H21.5234ZM32.8148 14.7516V22.2792H40.3425L32.8148 14.7516ZM22.4643 18.5154H26.2281C26.7457 18.5154 27.1691 18.9388 27.1691 19.4564C27.1691 19.9739 26.7457 20.3973 26.2281 20.3973H22.4643C21.9468 20.3973 21.5234 19.9739 21.5234 19.4564C21.5234 18.9388 21.9468 18.5154 22.4643 18.5154ZM22.4643 22.2792H26.2281C26.7457 22.2792 27.1691 22.7027 27.1691 23.2202C27.1691 23.7377 26.7457 24.1612 26.2281 24.1612H22.4643C21.9468 24.1612 21.5234 23.7377 21.5234 23.2202C21.5234 22.7027 21.9468 22.2792 22.4643 22.2792ZM25.6518 37.2052C25.2931 38.399 24.1933 39.2165 22.9465 39.2165H22.4643C21.9468 39.2165 21.5234 38.7931 21.5234 38.2755C21.5234 37.758 21.9468 37.3346 22.4643 37.3346H22.9465C23.3641 37.3346 23.7287 37.064 23.8463 36.6641L24.7226 33.753C24.9226 33.0885 25.5342 32.6298 26.2281 32.6298C26.9221 32.6298 27.5337 33.0826 27.7337 33.753L28.4159 36.0231C28.8511 35.6585 29.4039 35.4527 29.992 35.4527C30.927 35.4527 31.7798 35.9819 32.1973 36.817L32.4561 37.3346H35.6377C36.1552 37.3346 36.5787 37.758 36.5787 38.2755C36.5787 38.7931 36.1552 39.2165 35.6377 39.2165H31.8739C31.5151 39.2165 31.1917 39.0165 31.0329 38.699L30.5154 37.658C30.4154 37.4581 30.2154 37.3346 29.9979 37.3346C29.7803 37.3346 29.5744 37.4581 29.4803 37.658L28.9628 38.699C28.7922 39.0459 28.4217 39.2518 28.0395 39.2165C27.6572 39.1812 27.3279 38.9166 27.222 38.5519L26.2281 35.2762L25.6518 37.2052Z" fill="url(#paint0_linear_31_379)"/>
    </g>
    <defs>
    <linearGradient id="paint0_linear_31_379" x1="17.7595" y1="19.9021" x2="37.5692" y2="44.8622" gradientUnits="userSpaceOnUse">
    <stop stopColor="#413CE3"/>
    <stop offset="1" stopColor="#8735EE"/>
    </linearGradient>
    <clipPath id="clip0_31_379">
    <rect width="22.583" height="30.1106" fill="white" transform="translate(17.7595 14.7516)"/>
    </clipPath>
    </defs>
    </svg>
    
  );
};
export const WebsiteAndAppIcon = () => {
  return (
    <svg className=" max-[400px]:w-[40px]" xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58" fill="none">
    <rect x="1.56582" y="1.4064" width="54.8005" height="54.8005" rx="27.4002" stroke="#463CE4" strokeWidth="1.7625"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M25.1694 14.2595C22.103 15.1514 19.3769 16.9475 17.3472 19.4129C15.3175 21.8784 14.0786 24.8987 13.7922 28.0793H21.0432C21.4635 23.2395 22.8668 18.5362 25.1672 14.2572L25.1694 14.2595ZM21.0432 30.9117H13.7922C14.078 34.0925 15.3164 37.1131 17.3457 39.579C19.375 42.0449 22.1009 43.8414 25.1672 44.7339C22.8668 40.4549 21.4635 35.7516 21.0432 30.9117ZM28.8017 45.3389C26.0527 40.9826 24.3682 36.0401 23.8846 30.9117H35.2936C34.81 36.0401 33.1255 40.9826 30.3765 45.3389C29.8519 45.3643 29.3263 45.3643 28.8017 45.3389ZM34.0133 44.7316C37.0793 43.8393 39.8049 42.0431 41.8342 39.5776C43.8634 37.1122 45.1021 34.0921 45.3882 30.9117H38.1373C37.7169 35.7516 36.3137 40.4549 34.0133 44.7339V44.7316ZM38.1373 28.0793H45.3882C45.1025 24.8986 43.8641 21.878 41.8348 19.4121C39.8055 16.9462 37.0796 15.1497 34.0133 14.2572C36.3137 18.5362 37.717 23.2394 38.1373 28.0793ZM28.8017 13.6522C29.3271 13.6265 29.8534 13.6265 30.3788 13.6522C33.127 18.0087 34.8107 22.9511 35.2936 28.0793H23.8869C24.3786 22.9198 26.0667 17.9733 28.8017 13.6522Z" fill="url(#paint0_linear_31_375)"/>
    <defs>
      <linearGradient id="paint0_linear_31_375" x1="18.1985" y1="16.7173" x2="36.7048" y2="45.358" gradientUnits="userSpaceOnUse">
        <stop stopColor="#3E3CE2"/>
        <stop offset="1" stopColor="#8336ED"/>
      </linearGradient>
    </defs>
  </svg>
  );
};
export const BountyProgramIcon = () => {
  return (
    <svg className=" max-[400px]:w-[40px]" xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58" fill="none">
    <rect x="1.56383" y="1.36937" width="54.8745" height="54.8745" rx="27.4373" stroke="#463CE4" strokeWidth="1.68845"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M22.5802 21.572C13.1962 32.2581 14.5544 38.1679 16.4065 39.787C25.2967 45.6157 32.4582 44.6443 34.9276 43.4299C43.8178 41.487 43.9824 35.7392 42.9535 33.1081C42.9535 28.2508 38.4261 23.3935 36.1624 21.572L39.2492 16.7147C29.3713 11.8574 21.9629 14.6908 19.4934 16.7147L22.5802 21.572ZM32.0095 28.0957C32.6044 28.5163 33.0543 29.1111 33.2972 29.798C33.3357 29.9071 33.3524 30.0226 33.3462 30.1381C33.3401 30.2536 33.3112 30.3668 33.2613 30.4711C33.2115 30.5755 33.1415 30.669 33.0555 30.7463C32.9695 30.8236 32.8691 30.8833 32.76 30.9218C32.6509 30.9603 32.5353 30.9769 32.4198 30.9708C32.3043 30.9646 32.1912 30.9358 32.0868 30.8859C31.8761 30.7851 31.714 30.6048 31.6362 30.3845C31.5147 30.0411 31.2898 29.7438 30.9923 29.5336C30.6948 29.3233 30.3395 29.2105 29.9752 29.2106V32.7334C30.9095 32.7334 31.8056 33.1045 32.4662 33.7652C33.1269 34.4258 33.498 35.3219 33.498 36.2562C33.498 37.1905 33.1269 38.0865 32.4662 38.7472C31.8056 39.4078 30.9095 39.779 29.9752 39.779V40.6597H28.2138V39.779C27.4852 39.779 26.7745 39.5531 26.1796 39.1324C25.5846 38.7118 25.1347 38.1171 24.8918 37.4301C24.8494 37.3203 24.8295 37.203 24.8333 37.0853C24.837 36.9676 24.8643 36.8519 24.9136 36.7449C24.9629 36.6379 25.0331 36.542 25.1201 36.4626C25.2071 36.3832 25.3091 36.3222 25.4202 36.2829C25.5312 36.2437 25.649 36.2271 25.7665 36.2342C25.8841 36.2413 25.999 36.2719 26.1045 36.3241C26.21 36.3764 26.304 36.4493 26.3808 36.5385C26.4577 36.6278 26.5159 36.7315 26.5519 36.8436C26.795 37.5288 27.4476 38.0176 28.2138 38.0176V34.4948C27.2795 34.4948 26.3835 34.1236 25.7228 33.463C25.0622 32.8023 24.691 31.9063 24.691 30.972C24.691 30.0377 25.0622 29.1416 25.7228 28.481C26.3835 27.8203 27.2795 27.4492 28.2138 27.4492V26.5685H29.9752V27.4492C30.7038 27.4492 31.4145 27.6751 32.0095 28.0957ZM26.9683 29.7265C27.2986 29.3961 27.7467 29.2106 28.2138 29.2106V32.7334C27.7467 32.7334 27.2986 32.5478 26.9683 32.2175C26.638 31.8871 26.4524 31.4391 26.4524 30.972C26.4524 30.5048 26.638 30.0568 26.9683 29.7265ZM31.2207 37.5017C30.8904 37.832 30.4424 38.0176 29.9752 38.0176V34.4948C30.4424 34.4948 30.8904 34.6803 31.2207 35.0107C31.551 35.341 31.7366 35.789 31.7366 36.2562C31.7366 36.7233 31.551 37.1713 31.2207 37.5017Z" fill="url(#paint0_linear_31_366)"/>
    <defs>
      <linearGradient id="paint0_linear_31_366" x1="15.0714" y1="21.4021" x2="28.889" y2="38.9044" gradientUnits="userSpaceOnUse">
        <stop stopColor="#473BE4"/>
        <stop offset="1" stopColor="#8536ED"/>
      </linearGradient>
    </defs>
  </svg>
  );
};
